import {projects_list_init} from "../projects/projects_list";
import {init_marques} from "../animations/marquee";
import {init_scroll_to_content} from "../animations/scrollToContentLink";
import {init_circle_square} from "../animations/circle_square";

import hljs from 'highlight.js/lib/core';
import {project_single_init} from "../project-single/project.js";


const app_initialisation = (container) => {
    projects_list_init(container);
    init_marques(container);
    init_scroll_to_content(container);
    init_circle_square(container);
    project_single_init(container);
    hljs.highlightAll();
}

export default app_initialisation;
